import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

export const guestGuard: CanActivateFn = () => {
    const sessionService = inject(SessionService);
    const router = inject(Router);

    return sessionService.isAuthenticated()
        ? router.createUrlTree(['/'])
        : true;
};
